import React from 'react';
import { Container, Box, Typography, Fade } from '@mui/material';
import { EvStation } from '@mui/icons-material';
import ControlCargadores from '../../components/MovilidadElectrica/ControlCargadores';
import { MovilidadElectricaProvider } from '../../context/MovilidadElectricaContext';
import Navbar from '../../components/Navbar';
import VerticalMenu from '../../components/VerticalMenu';
import Footer from '../../components/Footer';

const ControlCargadoresPage = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <MovilidadElectricaProvider>
      <Navbar toggleMenu={toggleMenu} />
      <div style={{ display: 'flex' }}>
        <VerticalMenu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
        <main style={{ flexGrow: 1 }}>
          <Container 
            maxWidth={false}
            sx={{ 
              maxWidth: '1600px',
              px: { xs: 2, sm: 3, md: 4 },
              py: { xs: 3, sm: 4 }
            }}
          >
            <Fade in timeout={600}>
              <Box>
                {/* Header moderno */}
                <Box
                  sx={{
                    background: 'linear-gradient(135deg, #002642 0%, #00577A 100%)',
                    borderRadius: 4,
                    p: { xs: 3, sm: 4 },
                    mb: 4,
                    color: '#FFFFFF',
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0,
                      background: 'linear-gradient(135deg, rgba(219, 150, 0, 0.1) 0%, rgba(219, 150, 0, 0.05) 100%)',
                      pointerEvents: 'none'
                    }
                  }}
                >
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: { xs: 2, sm: 3 },
                    position: 'relative',
                    zIndex: 1
                  }}>
                    <Box
                      sx={{
                        p: { xs: 1.5, sm: 2 },
                        borderRadius: 3,
                        backgroundColor: 'rgba(255, 255, 255, 0.15)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <EvStation sx={{ 
                        fontSize: { xs: '1.8rem', sm: '2.2rem' }, 
                        color: '#DB9600' 
                      }} />
                    </Box>
                    <Box>
                      <Typography 
                        variant="h4" 
                        component="h1"
                        sx={{ 
                          fontWeight: 700,
                          fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2.2rem' },
                          mb: 1,
                          textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                        }}
                      >
                        Control de Cargadores
                      </Typography>
                      <Typography 
                        variant="body1"
                        sx={{ 
                          opacity: 0.9,
                          fontSize: { xs: '0.9rem', sm: '1rem' },
                          fontWeight: 400
                        }}
                      >
                        Gestión y monitoreo de estaciones de carga
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <ControlCargadores />
              </Box>
            </Fade>
          </Container>
        </main>
      </div>
    </MovilidadElectricaProvider>
  );
};

export default ControlCargadoresPage;
